import { combineReducers } from 'redux-merge-immutable-reducers';
import { handleActions, combineActions } from 'redux-actions';
import { fromJS, Map } from 'immutable';

import actions from '@synergycms_app/store/actions'
import params from '@synergycms_core/store/customer/params';

//REDUCERS
const {
  langInfo: langActions,
  webType: webTypeActions,
  currentHotel: currentHotelActions,
} = actions.customer;

const lang_info = handleActions(
  {
    [langActions.get.toString()]: (langInfo, { payload }) => {
      return fromJS(payload);
    }
  },
  Map()
);

const web_type = handleActions(
  {
    [webTypeActions.get.toString()]: (webType, { payload }) => {
      return payload;
    }
  },
  String()
);

const current_hotel = handleActions(
  {
    [combineActions(currentHotelActions.set.toString(), currentHotelActions.clear.toString())]: (
      hotel,
      { payload }
    ) => {
      return payload;
    }
  },
  null
);


export default combineReducers({
  params,
  lang_info,
  web_type,
  current_hotel
});
